import { render } from "./LoginOperators.vue?vue&type=template&id=28741984&scoped=true"
import script from "./LoginOperators.vue?vue&type=script&lang=js"
export * from "./LoginOperators.vue?vue&type=script&lang=js"

import "./LoginOperators.vue?vue&type=style&index=0&id=28741984&scoped=true&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28741984"]])

export default __exports__